import { render } from "./ChatView.vue?vue&type=template&id=344fe04c"
import script from "./ChatView.vue?vue&type=script&lang=js"
export * from "./ChatView.vue?vue&type=script&lang=js"

import exportComponent from "Z:\\Adamovyveci\\uhkprojects\\owezaverecny\\secutalk\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__